module.exports = __webpack_public_path__ + "static/media/404.e1e84671.svg";